import { h } from 'preact';

// path from Figma node 2235:988 (chevron-right-mini), centered in 20×20 container
export const ChevronRightMiniIcon = ({ stroke = '#888888', ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <path d="M8.21 5.83L11.79 10L8.21 14.17" stroke={stroke} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
